import React, { useRef } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import {
	unscheduledColumnWidth,
	scrollbarWidth,
} from '@atlassian/jira-platform-board-kit/src/common/constants/styles/index.tsx';
import { ScrollStateContextProvider } from '@atlassian/jira-software-fast-virtual/src/services/use-scroll-state/index.tsx';
import { useScrollUpdateHandler } from '@atlassian/jira-scroll-interceptor/src/controllers/scroll-update-handler/index.tsx';
import Board from '../../board-container/board/index.tsx';
import UnscheduledWorkSwimlanesContainer from '../../board-container/board/unscheduled-work-swimlanes-container/index.tsx';
import ScrollObserver from '../../board-container/scroll-observer/index.tsx';

export const UnscheduledWorkPanel = () => {
	const scrollingElementRef = useRef<HTMLElement | null>(null);
	return (
		<Box
			xcss={UnscheduledWorkContainerStyles}
			testId="software-board.board-panels.unscheduled-work-panel"
		>
			<Board scrollRef={scrollingElementRef} isUnscheduledWorkColumnPanel>
				<ScrollStateContextProvider scrollRef={scrollingElementRef}>
					<UnscheduledWorkSwimlanesContainer />
				</ScrollStateContextProvider>
				<ScrollInterceptorWrapper scrollEl={scrollingElementRef.current} />
				<ScrollObserver />
			</Board>
		</Box>
	);
};

type ScrollInterceptorWrapperProps = {
	scrollEl: HTMLElement | null;
};

const ScrollInterceptorWrapper = ({ scrollEl }: ScrollInterceptorWrapperProps) => {
	useScrollUpdateHandler(scrollEl);

	return null;
};

const UnscheduledWorkContainerStyles = xcss({
	// Calculate inner content width plus padding on each side and scrollbar width
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `calc(${unscheduledColumnWidth} + ${scrollbarWidth} + (${token('space.050')} * 2))`,
	height: '100%',
	overflowY: 'auto',
	overflowX: 'hidden',
	display: 'flex',
	backgroundColor: 'elevation.surface',
	zIndex: 'card',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `1px solid ${token('color.border')}`,
	borderRadius: 'border.radius.200',
	position: 'relative',
	flexShrink: 0,
});
